import { z } from "zod";

import {
  addCustomFieldIssues,
  addressSchema,
  customFieldsSchema,
} from "components/BaseForm";

/**
 * The Case form schema. Name and Product Line are the fields the legacy form
 * required before it enabled Save.
 */
export const buildCaseSchema = ({ customFieldConfigs }) =>
  z
    .object({
      name: z.string().trim().min(1, "Name is required"),
      entity_id: z.number().nullable(),
      case_investigators: z.array(z.number()),
      investigation_status_id: z.number().nullable(),
      website: z.array(z.string()),
      industry: z.string().trim(),
      company_description: z.string().trim(),
      actionable_domain: z.string().trim(),
      region_id: z.number().nullable(),
      country: z.string().nullable(),
      source_status_id: z.number().nullable(),
      product_line_id: z.number({
        required_error: "Product Line is required",
        invalid_type_error: "Product Line is required",
      }),
      addresses: z.array(addressSchema),
      tags: z.array(z.any()),
      custom_fields: customFieldsSchema,
    })
    .superRefine((values, ctx) =>
      addCustomFieldIssues(customFieldConfigs, values.custom_fields, ctx)
    );
